<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar" />
      </div>
      <div class="flex-fill overflow-auto pa-5 d-flex align-center justify-center">
        <div class="text-center">
          <ContactRequestMessage v-if="$route.query.contactRequest" />
          <GoodByeMessage v-else-if="$route.query.goodBye" />
          <LeaveQueue v-else-if="$route.query.leaveQueue" />
          <Scheduling v-else-if="$route.query.scheduling" />
          <Disconnected v-else-if="$route.query.fromQueue" />

          <div class="actions mt-5">
            <v-btn
              v-if="btnPrimaryConfig.data"
              class="font-weight-bold os-rounded"
              type="submit"
              block
              elevation="0"
              :color="btnPrimaryConfig.data.btn"
              :style="`color: ${btnPrimaryConfig.data.text}`"
              @click="leave()"
            >
              OK
            </v-btn>
          </div>
        </div>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    ContactRequestMessage: () => import(/* webpackPrefetch: true */ '@/views/thank-you-page/resources/ContactRequestMessage.vue'),
    GoodByeMessage: () => import(/* webpackPrefetch: true */ '@/views/thank-you-page/resources/GoodByeMessage.vue'),
    LeaveQueue: () => import(/* webpackPrefetch: true */ '@/views/thank-you-page/resources/LeaveQueue.vue'),
    Scheduling: () => import(/* webpackPrefetch: true */ '@/views/thank-you-page/resources/Scheduling.vue'),
    Disconnected: () => import(/* webpackPrefetch: true */ '@/views/thank-you-page/resources/Disconnected.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue')
  },
  computed: {
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    }
  }
})
export default class Index extends Vue {
  mounted () {
    this.ocGoogleAnalyticsInit()

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Se finalizó el proceso exitosamente',
      detail: 'Se finalizó el proceso exitosamente en la vista de gracias.',
      actionType: 'FNAN',
      functionality: 13,
      historyInteractionType: 'OSIFDV'
    })

    this.$storage.initializeStorageData(true)
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  ocGoogleAnalyticsExit () {
    if (this.$route.query.scheduling) {
      OcGoogleAnalytics.getDataLayerConfig('scheduling.exit')
    }

    OcGoogleAnalytics.getDataLayerConfig('exit')
  }

  leave () {
    this.ocGoogleAnalyticsExit()
    if (this.$organization.hideOnFinish()) {
      this.$widget.hide()
    } else {
      this.$widget.toggle(false)
    }

    setTimeout(() => {
      this.$storage.initializeStorageData(true)

      if (this.$route.name !== 'home') {
        this.$router.replace({ path: '/' })
      }
    }, 500)
  }
}
</script>
